import {useServices} from '@/services/context'
import {useQuery} from '@tanstack/react-query'
import {useAuth} from '@/contexts/auth-context'
import {permissions} from '@/lib/permissions'

 

export function useErrorLogStats(period: string) {
    const services = useServices()
    return useQuery({
        queryKey: ['error-logs', 'stats', period],
        queryFn: () => services.errorLogs.stats(),
        refetchInterval: 60000,
    })
}

export function useErrorLogErrorTypes(queryString: string) {
    const services = useServices()
    return useQuery({
        queryKey: ['error-logs', 'error-types', queryString],
        queryFn: () => services.errorLogs.errorTypes(Object.fromEntries(new URLSearchParams(queryString))),
        refetchInterval: 60000,
    })
}

export function useErrorLogList(queryString: string) {
    const services = useServices()
    return useQuery({
        queryKey: ['error-logs', 'list', queryString],
        queryFn: () => services.errorLogs.list(Object.fromEntries(new URLSearchParams(queryString))),
        refetchInterval: 60000,
    })
}

export function useErrorLogDetail(id: string | undefined) {
    const services = useServices()
    return useQuery({
        queryKey: ['error-logs', 'detail', id],
        queryFn: () => services.errorLogs.detail(id!),
        enabled: !!id,
    })
}

export function useErrorLogBadgeCount() {
    const services = useServices()
    const {hasPermission} = useAuth()
    const canView = hasPermission(permissions.errorLogs.view)
    return useQuery({
        queryKey: ['error-logs', 'badge-count'],
        queryFn: () => services.errorLogs.badgeCount(),
        refetchInterval: 60000,
        enabled: canView,
    })
}

export function useErrorLogContextKeys() {
    const services = useServices()
    return useQuery({
        queryKey: ['error-logs', 'context-keys'],
        queryFn: () => services.errorLogs.contextKeys(),
    })
}

export function useErrorLogsByTemplate(templateId: string | undefined, queryString: string) {
    const services = useServices()
    return useQuery({
        queryKey: ['error-logs', 'by-template', templateId, queryString],
        queryFn: () => services.errorLogs.errorTypeOccurrences(templateId!, Object.fromEntries(new URLSearchParams(queryString))),
        enabled: !!templateId,
        refetchInterval: 60000,
    })
}
